﻿import {
  Avatar,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import Logout from '@mui/icons-material/Logout';
import React, { useContext, useState } from 'react';
import { MemberContext } from '../contexts/MemberContext';
import { useNavigate } from 'react-router';
import { sitePaths } from '../routes/paths';
import { Contact } from '../api/Common';

export function ProfileButton() {
  const { member, isLoading: isMemberLoading } = useContext(MemberContext);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Tooltip title="Account settings">
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <Avatar sx={{ width: 32, height: 32 }} />
        </IconButton>
      </Tooltip>
      <ProfileButtonMenu open={open} onClose={handleClose} member={member} anchorEl={anchorEl} />
    </>
  );
}

export default function ProfileButtonMenu(props: {
  open: boolean;
  onClose: () => void;
  member?: Contact;
  anchorEl?: Element | null;
}) {
  const { open, onClose, member, anchorEl } = props;
  const navigate = useNavigate();
  const handleLogout = () => {
    onClose();
    window.location.href = '/auth/logout';
  };

  const handleProfile = () => {
    onClose();
    navigate(sitePaths.member.profile);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={open}
      onClose={handleClose}
      onClick={handleClose}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <MenuItem>
        <Stack
          direction="column"
          spacing={0.5}
          sx={{
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
          }}
        >
          <Typography variant={'h6'}>{member?.name}</Typography>
          <Typography variant="body2" className={'text-muted'}>
            {member?.emailAddress}
          </Typography>
        </Stack>
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleProfile}>
        <Avatar /> Profile
      </MenuItem>
      <MenuItem onClick={handleLogout}>
        <ListItemIcon sx={{ mr: 0 }}>
          <Logout fontSize="small" />
        </ListItemIcon>
        Logout
      </MenuItem>
    </Menu>
  );
}
